import { Typography } from '@mui/material'
import React from 'react'

const Footer = () => {
  return (
    <footer>
      <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
        Desarrollado por Nest Consultores &#169;
      </Typography>
    </footer>
  )
}

export default Footer